export default "__VITE_ASSET__D3TW2KAO__"